import { useState } from 'react';
import { Modal } from 'src/components/Common/@electron/Modal';
import { RichText } from 'src/components/Common/@electron/RichText';
import usePreventBodyScroll from 'src/lib/Hooks/usePreventBodyScroll';
import { NoResultsModalProps } from '../types';

const NoResultsModal = ({
  header,
  subhead,
  startOverButtonText,
  cancelButtonText,
  handleCancel,
  startOver,
}: NoResultsModalProps) => {
  const [isOpen, setIsOpen] = useState(true);
  usePreventBodyScroll(isOpen);

  return (
    <Modal
      isOpen={isOpen}
      id="noContractorResultsModal"
      title={header}
      titleVariant="text-center"
      onClose={() => {
        setIsOpen(false);
        handleCancel?.();
      }}
      descriptionVariant="text-center"
      description={<RichText className="text-gray-dark" tag="p" value={subhead} />}
    >
      <footer className="flex-shrink-0 relative mt-8">
        <div className="container-xs flex flex-col sm:flex-row-reverse justify-center gap-12">
          <button
            className="btn btn-primary btn-sm btn-full"
            type="button"
            onClick={() => {
              setIsOpen(false);
              startOver?.();
            }}
          >
            {startOverButtonText}
          </button>
          <button
            className="btn btn-sm btn-secondary btn-full"
            type="button"
            onClick={() => {
              setIsOpen(false);
              handleCancel?.();
            }}
          >
            {cancelButtonText}
          </button>
        </div>
      </footer>
    </Modal>
  );
};

export default NoResultsModal;
